/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { settingControllerFindByKey } from '../fn/setting/setting-controller-find-by-key';
import { SettingControllerFindByKey$Params } from '../fn/setting/setting-controller-find-by-key';
import { settingControllerSearch } from '../fn/setting/setting-controller-search';
import { SettingControllerSearch$Params } from '../fn/setting/setting-controller-search';
import { settingControllerSetSettings } from '../fn/setting/setting-controller-set-settings';
import { SettingControllerSetSettings$Params } from '../fn/setting/setting-controller-set-settings';
import { SettingDto } from '../models/setting-dto';
import { SettingSearchResponseDto } from '../models/setting-search-response-dto';

@Injectable({ providedIn: 'root' })
export class SettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `settingControllerSearch()` */
  static readonly SettingControllerSearchPath = '/api/setting';

  /**
   * 설정 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerSearch$Response(params: SettingControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingSearchResponseDto>> {
    return settingControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 설정 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerSearch(params: SettingControllerSearch$Params, context?: HttpContext): Observable<SettingSearchResponseDto> {
    return this.settingControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SettingSearchResponseDto>): SettingSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `settingControllerSetSettings()` */
  static readonly SettingControllerSetSettingsPath = '/api/setting';

  /**
   * upsert.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerSetSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetSettings$Response(params: SettingControllerSetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return settingControllerSetSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * upsert.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerSetSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetSettings(params: SettingControllerSetSettings$Params, context?: HttpContext): Observable<void> {
    return this.settingControllerSetSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `settingControllerFindByKey()` */
  static readonly SettingControllerFindByKeyPath = '/api/setting/{key}';

  /**
   * 설정 단건 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerFindByKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerFindByKey$Response(params: SettingControllerFindByKey$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingDto>> {
    return settingControllerFindByKey(this.http, this.rootUrl, params, context);
  }

  /**
   * 설정 단건 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerFindByKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerFindByKey(params: SettingControllerFindByKey$Params, context?: HttpContext): Observable<SettingDto> {
    return this.settingControllerFindByKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<SettingDto>): SettingDto => r.body)
    );
  }

}
